import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { emailService } from "../../services/emailService";
import { FiMail } from "react-icons/fi";

function SendEmailForm({ show, onHide, emailDetails, user }) {
    const [formState, setFormState] = useState(emailDetails);
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");
    
    const handleChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value });
    };

    const sendEmail = async () => {
        try {
            setSending(true);

            const payload = {
                ...formState,
                clientId: user.clientId,
                clientGuid: user.clientGuid,
            };

            await emailService.send(payload);
            setSent(true);
            setError("");
        } catch (err) {            
            setError("Failed to send email. Please try again.");
            setSent(false);
        } finally {
            setSending(false);
        }
    };

    const handleClose = () => {
        setFormState(emailDetails);
        setSent(false);
        setError("");
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered size={"lg"}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FiMail className="mb-1 me-2" /> Contact Support
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {sent && (
                    <Alert variant="success" dismissible onClose={() => setSent(false)}>
                        Email sent successfully!
                    </Alert>
                )}
                {error && (
                    <Alert variant="danger" dismissible onClose={() => setError("")}>
                        {error}
                    </Alert>
                )}

                <Form>
                    <Form.Group controlId="fromMail">
                        <Form.Label>From Email</Form.Label>
                        <Form.Control
                            type="email"
                            name="fromMail"
                            value={formState.fromMail}
                            disabled
                        />
                    </Form.Group>

                    <Form.Group controlId="fromName" className="mt-2">
                        <Form.Label>Your Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="fromName"
                            value={formState.fromName}
                            disabled
                        />
                    </Form.Group>

                    <Form.Group controlId="subject" className="mt-2">
                        <Form.Label>Subject</Form.Label>
                        <Form.Control
                            type="text"
                            name="subject"
                            value={formState.subject}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group controlId="body" className="mt-2">
                        <Form.Label>Body</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={6}
                            name="body"
                            value={formState.body}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={sending}>
                    Close
                </Button>
                {!sent && (
                    <Button variant="primary" onClick={sendEmail} disabled={sending}>
                        {sending ? "Sending..." : "Send Email"}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}

export default SendEmailForm;
